import Layout from '@/layout'

export default [
  {
    path: '/home',
    component: Layout,
    redirect: '/home/index',
    children: [
      {
        path: 'index',
        name: '首页',
        meta: {
          i18n: 'dashboard',
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/home/index')
      },
      {
        path: 'dashboard',
        name: '控制台',
        meta: {
          i18n: 'dashboard',
          menu: false,
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/home/dashboard')
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: '/user/profile',
        component: () => import('@/views/user/profile/index'),
        name: '个人信息',
        meta: { title: '个人中心', icon: 'user', permission: '*' }
      }
    ]
  },
  {
    path: '/websiteinfo',
    component: Layout,
    name: '站点管理',
    hidden: true,
    children: [
      {
        path: '/',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/source/website-info')
      },
      {
        path: 'wed/:id(\\d+)',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/source/website-info')
      }
    ]
  },
  {
    path: '/office/hr/employee/detail',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/office/profile/profile')
      }
    ]
  },
  {
    path: '/servicesiteinfo',
    component: Layout,
    name: '服务区域管理',
    hidden: true,
    children: [
      {
        path: '/',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/source/servicesite-info')
      },
      {
        path: 'sed/:id(\\d+)',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/source/servicesite-info')
      }
    ]
  },
  {
    path: '/detailstatis',
    component: Layout,
    name: '订单统计详情',
    hidden: true,
    children: [
      {
        path: 'mossd/:id(\\d+)/:type',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/statis/details-statis')
      }
    ]
  },
  {
    path: '/route',
    component: Layout,
    name: '新增线路',
    hidden: true,
    children: [
      {
        path: '/',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/product/transport/route/routeset-add')
      }
    ]
  },
  {
    path: '/routelist',
    component: Layout,
    name: '线路列表',
    hidden: true,
    meta: {},
    children: [
      {
        path: '/',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/product/transport/route/routeset-list')
      }
    ]
  },
  {
    path: '/runningplan',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'ad/:lineId/:lineName',
        meta: {
          permission: '*'
        },
        component: () =>
          import(
            /* webpackChunkName: "views" */ '@/views/product/transport/runningplan/runningplan-info'
          )
      },
      {
        path: 'rp/:id(\\d+)',
        meta: {
          permission: '*'
        },
        component: () =>
          import(
            /* webpackChunkName: "views" */ '@/views/product/transport/runningplan/runningplan-info'
          )
      }
    ]
  },
  {
    path: '/couponDetails',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/marketing/coupon/coupon-details')
      }
    ]
  },
  {
    path: '/couponpkg',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/marketing/coupon/coupon-pkg')
      }
    ]
  },
  {
    path: '/sendCoupon',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '手动发券',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/marketing/activities/send-coupon')
      }
    ]
  },
  {
    path: '/distCountCoupon',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '首单优惠',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/marketing/activities/distcount-coupon')
      }
    ]
  },
  {
    path: '/order-reduce',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '下单立减',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/marketing/order-reduce/list')
      }
    ]
  },
  {
    path: '/limitCoupon',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '限时领券',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/marketing/activities/limit-coupon')
      }
    ]
  },
  {
    path: '/activityCoupon',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '领券活动',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/marketing/activities/activity-coupon')
      }
    ]
  },
  {
    path: '/sellCoupon',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '优惠套餐',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/marketing/activities/sell-coupon')
      }
    ]
  },
  {
    path: '/couponCodeRedemption',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '券码兑换',
        meta: {
          permission: '*'
        },
        component: () =>
          import(
            /* webpackChunkName: "views" */ '@/views/marketing/activities/coupon-code-redemption'
          )
      }
    ]
  },
  {
    path: '/winningRecord',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '中奖记录',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/marketing/activities/winning-record')
      }
    ]
  },
  {
    path: '/prizePool',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '奖品池',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/marketing/activities/prize-pool')
      }
    ]
  },
  {
    path: '/line',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'line-config',
        name: '线路配置',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/line/line-config')
      }
    ]
  },
  {
    path: '/articleDetail',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'ad/:id/:isHot',
        name: '帮助详情',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/home/article-detail')
      }
    ]
  },
  {
    path: '/articleSearch',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '搜索',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/home/article-search')
      }
    ]
  },
  {
    path: '/customer',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'user/index/:phone/:userId',
        name: '用户信息',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/customer/user/index')
      }
    ]
  },
  {
    path: '/dataCenter',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'source/detail/:appType?/:startDate?/:endDate?/:merchantId?',
        name: '资源应用明细',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views//dataCenter/source/detail')
      }
    ]
  },
  {
    path: '/data-analysis',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'driver-data/normal/detail/:id',
        name: '司机运营详情',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/data-analysis/driver-data/normal/detail')
      }
    ]
  },
  {
    path: '/luckyDraw',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '抽奖活动',
        meta: {
          permission: '*'
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/marketing/activities/prize-draw')
      }
    ]
  },
  {
    path: '/dialogAdvertising',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '弹窗',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/marketing/advertising/user-advertising-old.vue')
      }
    ]
  },
  {
    path: '/iconConfig',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: 'icon',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/marketing/advertising/user-advertising-old.vue')
      }
    ]
  },
  {
    path: '/topBanner',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '顶部banner',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/marketing/advertising/user-advertising-old.vue')
      }
    ]
  },
  {
    path: '/bottomDefaultBanner',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '底部banner默认',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/marketing/advertising/bottomBanner.vue')
      }
    ]
  },
  {
    path: '/historyDataList',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '历史广告列表',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/marketing/advertising/user-advertising-history.vue')
      }
    ]
  },
  {
    path: '/bottomNav',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '底部导航',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/marketing/advertising/BottomNav.vue')
      }
    ]
  },
  {
    path: '/FooterBannerList',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '底部banner列表',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/marketing/advertising/FooterBannerList.vue')
      }
    ]
  },
  {
    path: '/adgroup',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'create',
        name: '新增广告组',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/marketing/advertising/components/groupBanner/AdGroupPage')
      },
      {
        path: 'edit/:id',
        name: '编辑广告组',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/marketing/advertising/components/groupBanner/AdGroupPage')
      }
    ]
  },
  {
    path: '/channelList',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '渠道商',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/channelCode/list')
      }
    ]
  },
  {
    path: '/partnerList',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '业务合伙人',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/channelCode/partnerList')
      }
    ]
  },
  {
    path: '/taxRate',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '税率配置',
        meta: {
          permission: '*'
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/channelCode/taxrate')
      }
    ]
  },
  {
    path: '/DispatchResultOrder',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '订单视角',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/dispatch/result/components/order.vue')
      }
    ]
  },
  {
    path: '/DispatchResultDriver',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '司机视角',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/dispatch/result/components/driver.vue')
      }
    ]
  },
  {
    path: '/DriverTrajectory',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        name: '司机轨迹',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/ferry/drivermonitor/Trajectory.vue')
      }
    ]
  },
  {
    path: '/driverCommission',
    component: Layout,
    hidden: true,
    children: [
      {
        // 新增司机提成
        path: 'add',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/operation/rule/driverCommission/addOrEdit.vue')
      },
      {
        // 编辑司机提成
        path: 'edit/:id',
        meta: {
          permission: '*'
        },
        component: () => import('@/views/operation/rule/driverCommission/addOrEdit.vue')
      }
    ]
  }
]
